import './CartridgePlayers.css';

function GetLetterA(i, joueur)
{
    switch(i)
    {
        case 0: return "A -";
        case 1: return "B -";
        case 2: return "C -";
        case 3: return "Rpt";
        default: return ""
    }
}

function GetLetterX(i, joueur)
{
    switch(i)
    {
        case 0: return "X -";
        case 1: return "Y -";
        case 2: return "Z -";
        case 3: return "Rpt";
        default: return ""
    }
}

const CartridgePlayers = ({id, liveTeamA, liveTeamX, isFromSPID = false}) => {
    return(
        <div id={"c-" + id} className='players_content'>
            <table className='player' border={0}>
                <tbody>
                {
                    liveTeamA?.map((joueur, i) => {
                        if(isFromSPID && joueur !== undefined && joueur !== null )
                            {
                                if(joueur.trim().length !== 0)
                                {
                                    return(
                                        <tr key={'k' + i}>
                                            <td className='cell_player spid'>
                                                <span className='letter'>{GetLetterA(i, joueur)}</span> <span>{joueur}</span>
                                            </td>
                                        </tr>
                                    )
                                }
                            }
                            else if (joueur !== undefined && joueur !== null )
                            {
                                return ( 
                                    <tr key={'k' + i}><td className='cell_player'>
                                        <img 
                                            src={"./images/atlas_flags/" + joueur?.country_code?.toLowerCase()  + "-flag.jpg"} 
                                            alt = {joueur?.country_code}
                                            width="25"
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null; 
                                                currentTarget.src="./images/no-pictures.png";
                                            }}
                                        />
                                        <span style={{paddingLeft: '10px', fontWeight: 'normal'}}>
                                            {joueur?.prenom?.charAt(0)?.toUpperCase() + joueur?.prenom?.slice(1)?.toLowerCase()} {joueur?.nom} {joueur?.classement}
                                        </span>
                                    </td></tr>
                                )
                            }                                        
                    })
                }
                </tbody>
            </table>
            <table className='player'>
                <tbody>
                {
                    liveTeamX?.map((joueur, i) => {
                        if(isFromSPID && joueur !== undefined && joueur !== null && joueur.length > 0)
                            {
                                if(joueur.trim().length !== 0)
                                {
                                    return(
                                        <tr key={'k' + i}>
                                            <td className='cell_player spid'>
                                                <span className='letter'>{GetLetterX(i, joueur)}</span> <span>{joueur}</span>
                                            </td>
                                        </tr>
                                    )
                                }
                            }
                            else if (joueur !== undefined && joueur !== null )
                            {
                                return ( 
                                    <tr key={'k' + i}><td className='cell_player'>
                                        <img 
                                            src={"./images/atlas_flags/" + joueur?.country_code?.toLowerCase() + "-flag.jpg"} 
                                            alt = {joueur?.country_code}
                                            width="25"
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null; 
                                                currentTarget.src="./images/no-pictures.png";
                                            }}
                                        />
                                        <span style={{paddingLeft: '10px', fontWeight: 'normal'}}>
                                            {joueur?.prenom?.charAt(0)?.toUpperCase() + joueur?.prenom?.slice(1)?.toLowerCase()} {joueur?.nom} {joueur?.classement}
                                        </span>
                                    </td></tr>
                                )
                            }                                     
                    })
                }
                </tbody>
            </table>
        </div>
    )
}
export default CartridgePlayers;